import RPC from 'frame-rpc';

export default RPC;
